import { JSONparse } from './object'

// Form data expiration time: 4 hours in milliseconds
export const FORM_DATA_EXPIRATION_MS = 4 * 60 * 60 * 1000

export const storage = (() => {
  function setValue(key: string, value: string, expirationTimeInMs?: number) {
    globalThis.sessionStorage.setItem(
      key,
      JSON.stringify({
        value,
        time: expirationTimeInMs ? Date.now() + expirationTimeInMs : null,
      }),
    )
  }

  function getValue(key: string): string | null {
    const item = globalThis.sessionStorage.getItem(key)
    if (!item) {
      return null
    }
    const parsedItem = JSONparse(item) as {
      value: string
      time: number | null
    }
    if (
      !parsedItem ||
      typeof parsedItem !== 'object' ||
      !('value' in parsedItem) ||
      !('time' in parsedItem)
    ) {
      // Malformed or unexpected data, remove and return null
      globalThis.sessionStorage.removeItem(key)
      return null
    }
    if (parsedItem.time && Date.now() > parsedItem.time) {
      globalThis.sessionStorage.removeItem(key)
      return null
    }
    return parsedItem.value
  }

  return {
    setValue,
    getValue,
  }
})()
